import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const StatusBadge = ({ tone, children }) => (
  <Box
    component="span"
    sx={(theme) => ({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '26px',
      maxWidth: '100%',
      padding: '4px 12px',
      borderRadius: '999px',
      fontSize: '13px',
      fontWeight: 500,
      fontFamily: theme.typography.fontFamily,
      lineHeight: 1,
      whiteSpace: 'nowrap',
      backgroundColor: theme.palette.badge[tone].bg,
      color: theme.palette.badge[tone].text
    })}
  >
    {children}
  </Box>
);

StatusBadge.propTypes = {
  tone: PropTypes.oneOf(['success', 'warning', 'info', 'error', 'neutral'])
    .isRequired,
  children: PropTypes.node.isRequired
};

export default StatusBadge;
